import Media from './Media';
import { MediaContext } from './Media';

export default Media;
export { MediaContext };
